import { render, staticRenderFns } from "./SignupTextField.vue?vue&type=template&id=641bd252&scoped=true&"
import script from "./SignupTextField.vue?vue&type=script&lang=js&"
export * from "./SignupTextField.vue?vue&type=script&lang=js&"
import style0 from "./SignupTextField.vue?vue&type=style&index=0&id=641bd252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bd252",
  null
  
)

export default component.exports